export interface Table {
  id: string;
  name: string;
  minBalance: number; // 입장에 필요한 최소 보유금
  buyIn: number;      // 표시용 권장 스테이크(입장 게이트는 minBalance)
  rate: number;       // 마작 1점당 가상머니
}

export const TABLES: Table[] = [
  { id: 'nyumon', name: '입문', minBalance: 0, buyIn: 0, rate: 1 },
  { id: 'chogeup', name: '초급', minBalance: 10000, buyIn: 5000, rate: 10 },
  { id: 'junggeup', name: '중급', minBalance: 50000, buyIn: 20000, rate: 50 },
  { id: 'sanggeup', name: '상급', minBalance: 200000, buyIn: 80000, rate: 200 },
];

export function getTable(id: string): Table | undefined {
  return TABLES.find((t) => t.id === id);
}

export function canEnter(balance: number, table: Table): boolean {
  return balance >= table.minBalance;
}

/** 마작 점수 변화량(pointDelta)을 레이트로 환산해 지갑 잔액에 반영. 0 미만은 0으로. */
export function settleHand(balance: number, pointDelta: number, table: Table): number {
  const result = balance + pointDelta * table.rate;
  // NaN/Infinity 등 비정상 값이 잔액을 오염시켜 영속되는 것을 방지
  return Number.isFinite(result) ? Math.max(0, result) : balance;
}
